import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import PublicRoutes from './publicRoute';
import Layout from '../../../layout';
import Landing from '../../Landing';
import Home from '../../Home';
import Confirmation from '../../Confirmation';
import { ROUTES } from './routes';
import Closing from '../../Closing';

const AppRoutes = () => {
  return <Routes>
    {/* <Route path='' element={<Landing />} />
    <Route path={ROUTES.HOME} element={<PublicRoutes layout={Layout} component={Home} />} />
    <Route path={ROUTES.CONFIRMATION} element={<PublicRoutes layout={Layout} component={Confirmation} />} /> */}
    <Route path='' element={<PublicRoutes layout={Layout} component={Closing} />} />
    <Route path='*' element={<Navigate replace to="/" />} />
  </Routes>
}

export default AppRoutes;
